import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { mdiCheck, mdiChevronRight, mdiClose, mdiDotsVertical } from '@mdi/js';

import { CmpsInsightCoachingPerformanceComponent } from './insight-coaching-performance.component';

@NgModule({
    declarations: [CmpsInsightCoachingPerformanceComponent],
    imports: [CmpsIconModule, CmpsTooltipModule, CommonModule],
    exports: [CmpsInsightCoachingPerformanceComponent],
    entryComponents: [CmpsInsightCoachingPerformanceComponent],
})
export class CmpsInsightCoachingPerformanceModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['dots', mdiDotsVertical],
            ['chevron-right', mdiChevronRight],
            ['close', mdiClose],
            ['check', mdiCheck],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
